import { render } from "./SignupView.vue?vue&type=template&id=23892b2b&scoped=true"
import script from "./SignupView.vue?vue&type=script&lang=js"
export * from "./SignupView.vue?vue&type=script&lang=js"

import "./SignupView.vue?vue&type=style&index=0&id=23892b2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23892b2b"]])

export default __exports__